module.exports = __webpack_public_path__ + "static/media/07_topbandas_mobile.856389a1.jpg";